import { render, staticRenderFns } from "./DialogRemoveAccess.vue?vue&type=template&id=f7e64ffe&scoped=true"
import script from "./DialogRemoveAccess.js?vue&type=script&lang=js&external"
export * from "./DialogRemoveAccess.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e64ffe",
  null
  
)

export default component.exports